<template>
  <div class="container">
    <div class="shop_list" ref="wrapper">
      <div class="top">
        <img :src="orderInfo.actImgPath" alt="logo" class="topImage" />
        <div class="TopTitle">
          <p class="TopTitleText">{{orderInfo.actTitle}}</p>
        </div>
      </div>

      <div class="ActiveBody">
        <div class="Activetime border-bottom">
          <img src="../../assets/images/time.png" class="timeImage" />
          <span class="timeTitle">{{ date(orderInfo.actBegTime) }} 至 {{date(orderInfo.actEndTime)}}</span>
        </div>
        <div class="Activetime border-bottom">
          <img src="../../assets/images/icon_site.png" class="timeImage" />
          <span class="timeTitle">{{orderInfo.actAddress}}</span>
        </div>
        <!-- 报名信息 -->
        <div class="user_mess">
          <h3 class="border-bottom">报名信息</h3>
          <div class="Activetime0" v-if="activeReg" v-for="(item,index) in activeReg" :key="index">
            <span class="user_l">{{item.regDicName}}</span>
            <p class="user_r">{{item.regDicValue}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="button">
      <div class="footer_main">
        <div class="button_left_div">
          <span class="button_left__text1">待支付</span>
          <span class="button_left__text2">¥ {{orderInfo.payAmount|returnFloat}}</span>
        </div>
        <mt-button class="btn_zx btn_default" @click="goPay">去支付</mt-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getUnpaidOrderInfoByOrderId } from '../../utils/api';
import commonFooter from '../../components/commonFooter';
import { mapState } from 'vuex';
import ping from '../../utils/pingpay.js'
export default {
  name: 'activityDetails',
  components: {
    // commonHeader,
    commonFooter
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data() {
    return {
      orderInfo: '',
      activeReg: '',
      canPay: true
    };
  },
  created() {
    let query = this.$route.query;
    this.orderId = query.orderId;
    this.actId = query.actId;
    this.getActiveDetailByIdAction();
  },

  filters: {
    action() { },
    returnFloat(val) {
      var value = Math.round(parseFloat(val) * 100) / 100;
      var xsd = value.toString().split('.');
      if (xsd.length === 1) {
        value = value.toString() + '.00';
        return value;
      }
      if (xsd.length > 1) {
        if (xsd[1].length < 2) {
          value = value.toString() + '0';
        }
        return value;
      }
    }
  },
  methods: {
    date(value) {
      var Begdate = new Date(value);
      var Begyear = Begdate.getFullYear();
      var Begmonth = Begdate.getMonth() + 1;
      Begmonth = this.formatNumber(Begmonth);
      var Begday = Begdate.getDate();
      Begday = this.formatNumber(Begday);
      var Beghous = Begdate.getHours();
      Beghous = this.formatNumber(Beghous);
      var BegMinutes = Begdate.getMinutes();
      BegMinutes = this.formatNumber(BegMinutes);
      // var Seconds = Begdate.getSeconds();
      var str =
        Begyear +
        '-' +
        Begmonth +
        '-' +
        Begday +
        ' ' +
        Beghous +
        ':' +
        BegMinutes;

      return str;
    },
    formatNumber(n) {
      n = n.toString();
      return n[1] ? n : '0' + n;
    },

    // 活动详情
    getActiveDetailByIdAction() {
      let params = {
        userId: this.common.userId,
        actId: this.actId,
        orderId: this.orderId
      };
      getUnpaidOrderInfoByOrderId(params, {
        cityId: this.common.marketInfo.cityId,
        userId: this.common.userId,
        openId: this.common.openId,
        marketId: this.common.marketInfo.id
      }).then(res => {
        this.loaded = true;
        if (res.res.code === 10000) {
          this.orderInfo = res.body.orderInfo;
          this.activeReg = res.body.activeReg;
        }
      });
    },
    goPay() {
      if (!this.canPay) { return; }
      this.canPay = false;
      let params = {
        orderNo: this.$route.query.orderNo,
        repairNo: '', // "报修单号",
        bussinessType: "2",//会议室1,活动2,租赁账单3,物业报修4,保洁服务5,送水服务6
        feeCode: this.actId,
        // payType: '5', // "支付类型 0微信，1支付宝, 4万生活, 5,ping++"
        channel: 'wx_pub' // 渠道名
      };
      ping(params, '', res => {
        console.log(res);
        this.canPay = true;
        this.$router.push(`/myOrder`)
      }, () => {
        this.canPay = true;
        this.$router.push(`/myOrder`)
      }, () => {
        this.canPay = true;
        this.$router.push(`/myOrder`)
      }
      );
      setTimeout(() => { this.canPay = true; }, 1000)
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  min-height: 100vh;
  background: @colore;
}
.noMess {
  p {
    margin-top: 200px;
    .fontSize(14px);
    text-align: center;
    color: @color6;
  }
}
.shop_list {
  background: #fff;
  margin-bottom: 120px;
  .top {
    background-color: @colorw;
    flex-direction: row;
    padding-bottom: 36px;
    width: 100%;
    display: flex;
    .topImage {
      width: 231px;
      height: 160px;
      margin-left: 30px;
      margin-top: 36px;
    }
    .TopTitle {
      width: 443px;
      height: 160px;
      margin-left: 26px;
      margin-top: 36px;
      .TopTitleText {
        .fontSize(16px);
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 45px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: pre-line;
      }
    }
  }

  .ActiveBody {
    background-color: @colorw;
    flex-direction: column;
    padding-bottom: 25px;
    width: 100%;
    display: flex;
    border-top: 0.015rem solid #f8f8f8;
    .user_mess {
      border-top: 14px solid @colore;
      padding: 0 28px;
      h3 {
        height: 88px;
        line-height: 88px;
        font-size: 32px;
        color: rgba(51, 51, 51, 1);
        font-weight: bold;
      }
    }
    .Activetime0 {
      .flex();
      margin-top: 28px;
      .user_l {
        width: 132px;
        font-size: 28px;
        color: rgba(51, 51, 51, 1);
        line-height: 40px;
      }
      .user_r {
        font-size: 28px;
        color: rgba(51, 51, 51, 1);
        line-height: 40px;
        flex: 1;
        width: 550px;
        word-break: break-all;
      }
    }

    .Activetime {
      width: 690px;
      margin-left: 30px;
      margin-right: 30px;
      flex-direction: row;
      display: inline-flex;
      padding: 29px 0;
      .timeImage {
        margin-left: 4px;
        margin-top: 5px;
        width: 32px;
        height: 32px;
      }
      .iconfont {
        margin-left: 4px;
        .fontSize(20px);
        color: #ccc;
        display: block;
      }
      .timeTitle {
        width: 635px;
        margin-left: 18px;
        .fontSize(13px);
        color: @color3;
        line-height: 42px;
        word-break: break-all;
      }
    }
  }

  //   overflow: scroll;
}
.button {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  // box-shadow:0px -1px 14px 0px rgba(0,0,0,0.09);
  z-index: 333;
  background: #fff;
  height: 108px;
  width: 100%;
  .footer_main {
    margin: 0 28px;
    height: 108px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .button_left_div {
    .button_left__text1 {
      margin-right: 10px;
      .fontSize(14px);
      color: @color3;
    }

    .button_left__text2 {
      .fontSize(14px);
      color: #fc3f56;
    }
  }

  .btn_zx {
    width: 192px;
    height: 68px;
    background: @color17;
    text-align: center;
    line-height: 68px;
    .fontSize(14px);
    .btn();
    border-radius: 4px;
    display: block;
  }
}
</style>